import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { AlertResponse, BodyChangeStatus, BodyDashboard, JobResponse } from './tech-admin.models';

@Injectable({
  providedIn: 'root',
})
export class TechAdminService {
  constructor(private _http: HttpClient) {}

  //Authentication
  postGetAuthenticationDashboard(bodyDashboard: BodyDashboard): Observable<AlertResponse> {
    return this._http.post<any>(environment.URL_BASE_AUTHENTICATION + environment.subUrlDashboard, bodyDashboard);
  }

  postChangeStatusAuthentication(body: BodyChangeStatus): Observable<any> {
    return this._http.post<any>(environment.URL_BASE_AUTHENTICATION + environment.subUrlChangeAlertWarningStatus, body);
  }

  //Signature
  postGetSignatureDashboard(bodyDashboard: BodyDashboard): Observable<AlertResponse> {
    return this._http.post<any>(environment.URL_BASE_SIGNATURE + environment.subUrlDashboard, bodyDashboard);
  }
  postChangeStatusSignature(body: BodyChangeStatus): Observable<any> {
    return this._http.post<any>(environment.URL_BASE_SIGNATURE + environment.subUrlChangeAlertWarningStatus, body);
  }

  //Request
  postGetRequestDashboard(bodyDashboard: BodyDashboard): Observable<AlertResponse> {
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlDashboard, bodyDashboard);
  }
  postChangeStatusRequest(body: BodyChangeStatus): Observable<any> {
    return this._http.post<any>(environment.URL_BASE_REQUEST + environment.subUrlChangeAlertWarningStatus, body);
  }

  //Administration
  postGetAdministrationDashboard(bodyDashboard: BodyDashboard): Observable<AlertResponse> {
    return this._http.post<any>(environment.URL_BASE_ADMIN + environment.subUrlDashboard, bodyDashboard);
  }
  postChangeStatusAdministration(body: BodyChangeStatus): Observable<any> {
    return this._http.post<any>(environment.URL_BASE_ADMIN + environment.subUrlChangeAlertWarningStatus, body);
  }

  //Jobs
  postGetJobsDashboard(): Observable<JobResponse> {
    return this._http.get<any>(environment.URL_BASE_AUTHENTICATION + environment.subUrlGetJobs);
  }
  postChangeStatusJob(nameJob: string, statusJob: string): Observable<any> {
    let flag = true;
    if (statusJob == 'OFF') {
      flag = false;
    }
    return this._http.post<any>(
      environment.URL_BASE_AUTHENTICATION +
        environment.subUrlChangeJobWarningStatus +
        '?job=' +
        nameJob +
        '&status=' +
        flag,
      null
    );
  }
}
